module.exports = __webpack_public_path__ + "img/IMG_0079_L_Black.90c2fd90.jpg";